import React from 'react';
import { getCountryName } from '../../../../utils/countryNamesClient';
import SecurityStatusPill from './ui/SecurityStatusPill';
import SecurityEmptyState from './ui/SecurityEmptyState';
import { IconActivity, IconGlobe, IconServer } from '../../ui/adminIcons';

function OverviewPanel({ title, icon, children }) {
  return (
    <div className="vx-sec-panel">
      <div className="vx-sec-panel-header">
        <span className="vx-sec-section-icon" aria-hidden="true">{icon}</span>
        <h3 className="vx-sec-panel-title">{title}</h3>
      </div>
      {children}
    </div>
  );
}

export default function SecurityOverviewGrid({ dashboardData }) {
  const severity = dashboardData.severityCounts || {};

  return (
    <div className="vx-sec-grid vx-sec-grid--charts">
      <OverviewPanel title="Severity distribution" icon={<IconActivity />}>
        <ul className="vx-sec-severity-list">
          <li><span>Critical</span><span className="vx-sec-kv-value vx-sec-kv-value--critical">{severity.CRITICAL || 0}</span></li>
          <li><span>High</span><span className="vx-sec-kv-value vx-sec-kv-value--warning">{severity.HIGH || 0}</span></li>
          <li><span>Medium</span><span className="vx-sec-kv-value">{severity.MEDIUM || 0}</span></li>
          <li><span>Low</span><span className="vx-sec-kv-value vx-sec-kv-value--safe">{severity.LOW || 0}</span></li>
        </ul>
      </OverviewPanel>

      <OverviewPanel title="Geographic distribution" icon={<IconGlobe />}>
        {dashboardData.geoDistribution?.length > 0 ? (
          <ul className="vx-sec-geo-list">
            {dashboardData.geoDistribution.slice(0, 5).map((geo) => (
              <li key={geo.country}>
                <span>{getCountryName(geo.country)}</span>
                <span>{geo.count}</span>
              </li>
            ))}
          </ul>
        ) : (
          <SecurityEmptyState title="No geographic data" />
        )}
      </OverviewPanel>

      <OverviewPanel title="System status" icon={<IconServer />}>
        <ul className="vx-sec-system-list">
          <li>
            <span>Database</span>
            <SecurityStatusPill
              active={dashboardData.systemHealth?.databaseConnected}
              activeLabel="Connected"
              inactiveLabel="Disconnected"
            />
          </li>
          <li>
            <span>Monitoring</span>
            <SecurityStatusPill
              active={dashboardData.systemHealth?.monitoringEnabled}
              activeLabel="Active"
              inactiveLabel="Disabled"
            />
          </li>
          <li>
            <span>Uptime</span>
            <span className="vx-sec-kv-value">
              {Math.floor((dashboardData.systemHealth?.uptime || 0) / 3600)}h{' '}
              {Math.floor(((dashboardData.systemHealth?.uptime || 0) % 3600) / 60)}m
            </span>
          </li>
        </ul>
      </OverviewPanel>
    </div>
  );
}
